import React from "react";

const BodyQuiz = ({ children }) => {
  return <>{children}</>;
};

export default BodyQuiz;
